import React, { useEffect, useState } from 'react';

import { Table, Typography, Alert } from 'antd';
import { createCoreAxiosInstance } from 'createAxiosInstance';
import PropTypes from 'prop-types';

const { Title } = Typography;

const columns = [
	{
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
		width: 80,
	},
	{
		title: 'POS',
		dataIndex: ['payload', 'point_of_sale_integration'],
		key: 'pos',
		width: 200,
	},
	{
		title: 'Captured At',
		dataIndex: 'created_at',
		key: 'created_at',
		width: 200,
		render: (date) => (date ? new Date(date).toLocaleString() : '-'),
	},
];

const expandedRowRender = (record) => (
	<pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
		{record.payload ? JSON.stringify(record.payload, null, 2) : '-'}
	</pre>
);

PosPayloads.propTypes = {
	orderId: PropTypes.number,
};

export default function PosPayloads({ orderId }) {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (!orderId) return;

		let cancelled = false;
		const fetchPayloads = async () => {
			setLoading(true);
			setError(null);
			try {
				const axios = await createCoreAxiosInstance();
				const response = await axios.get(`/api/corpa/pos-payload/${orderId}/`);
				if (!cancelled) {
					setData(response.data);
				}
			} catch (err) {
				if (!cancelled) {
					setError(err.message || 'Failed to load POS payloads');
				}
			} finally {
				if (!cancelled) {
					setLoading(false);
				}
			}
		};
		fetchPayloads();
		return () => {
			cancelled = true;
		};
	}, [orderId]);

	return (
		<>
			<Title level={4}>POS Payloads</Title>
			{error && (
				<Alert
					message="Error loading POS payloads"
					description={error}
					type="error"
					showIcon
					style={{ marginBottom: 16 }}
				/>
			)}
			<Table
				columns={columns}
				dataSource={data}
				rowKey="id"
				loading={loading}
				expandable={{ expandedRowRender }}
				pagination={false}
				locale={{
					emptyText: 'No POS payloads captured for this order (last 7 days)',
				}}
			/>
		</>
	);
}
